import Tengen from '../img/tengen.png';

export const Header = () => {
  return (
    <header className='header-container'>
      <h1 className='fs-1 text-center box-header'>Strombilanz Tengen</h1>
      <a
        className='position-logo pointing'
        href='https://www.tengen.de/pb/home.html'
        target='_blank'
        rel='noopener noreferrer'
      >
        <img
          src={Tengen}
          alt='Pebbles'
          width='180px'
          className='header-logo'
          draggable='false'
        />
      </a>
    </header>
  );
};
